/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import axios from 'axios';

import getTeamsUrl from '../../../utils/getTeamsUrl';

import { ArrowDownToLine, Download, Loader2 } from 'lucide-react';
import { IconButton } from '@/components/ui/custom/IconButton';
import { cn } from '@/lib/utils';
import download from '../../../utils/download';

const ImageComponent = ({
	src,
	onImageLoad,
	openLightbox,
	name = '',
	item,
	isInMessageContainer,
}) => {
	const [imageData, setImageData] = useState(null);
	const [type, setType] = useState(null);

	// const token = store.get('jwt');

	useEffect(() => {
		const loadImage = async () => {
			try {
				if (src && src.includes('giphy.com')) {
					onImageLoad(src);
					setImageData(src);
					// Sidebar/modal callers may omit `item`; default so we don't spin forever
					setType(item?.type || 'image/gif');
					return;
				}

				const response = await axios.get(
					`${getTeamsUrl(window.location.href)}/image?location=${src}`
				);

				if (!response.data) {
					return;
				}

				const { signedUrl } = response.data;

				if (!signedUrl) {
					return;
				}

				const imageResponse = await fetch(signedUrl);

				const blob = await imageResponse.blob();

				setType(blob.type);

				const imageUrl = URL.createObjectURL(blob);

				onImageLoad(imageUrl);
				setImageData(imageUrl);
			} catch (error) {
				console.error(error);
			}
		};

		loadImage();
	}, []);

	if (imageData && type && type.includes('image')) {
		return (
			<img
				src={imageData}
				alt="team-chat-upload"
				className="rounded-2xl border border-border/60"
				style={{
					maxWidth: '100%',
					maxHeight: '100%',
					objectFit: 'contain',
					// borderRadius: isInMessageContainer ? '15px' : '5px',
				}}
				onClick={openLightbox}
			/>
		);
	}

	if (imageData && type && !type.includes('image')) {
		return (
			<div
				style={{
					flexDirection: 'column',
					display: 'block',
					padding: '4px',
					width: isInMessageContainer ? '160px' : '100%',
				}}
				className="rounded-2xl border border-border/60"
			>
				<div
					style={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'space-between',
					}}
					className={cn(
						isInMessageContainer ? 'text-sm pb-1' : 'text-[10px]'
					)}
				>
					Shared file
				</div>

				<div
					style={{
						borderRadius: '10px',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
					className={cn(
						isInMessageContainer
							? 'flex items-center justify-between px-2'
							: 'p-1',
						'text-xs bg-muted rounded-xl'
					)}
				>
					<p className="line-clamp-2 text-wrap break-words">{name}</p>
					{isInMessageContainer && (
						<div>
							<IconButton
								onClick={() => {
									download(imageData, item.name);
								}}
							>
								<ArrowDownToLine className="size-4" />
							</IconButton>
						</div>
					)}
				</div>
			</div>
		);
	}

	return (
		<div
			style={{
				flexDirection: 'column',
				borderRadius: '15px',
				fontSize: 14,
				display: 'block',
				width: isInMessageContainer ? '100px' : '100%',
				height: isInMessageContainer ? '50px' : '100%',
			}}
		>
			<Loader2 className="size-6 animate-spin text-primary" />
		</div>
	);
};

export default ImageComponent;
